import Vue from 'vue'
import commonPlugin from '@weipu/vue-common'
import '@weipu/vue-common/lib/main.css'

// common组件注册
Vue.use(commonPlugin, {
  tokenCode: 'offical-admin',
  dynamicForm: {
    type: 'element-ui'
  },
  catchException: (data) => {
    if (data && data.resultCode === '401') {
      console.log('reload data', data)
      location.reload()
    } else {
      Vue.$message.error('请求异常：' + data.resultCode + ':' + data.message)
      throw data
    }
  }
})


// WEBPACK FOOTER //
// ./src/plugins/commonPlugin.js